import { PrivateImage } from "./PrivateImage";
import { Bot } from "lucide-react";
import { avatarColor, initials } from "../workspace/format";
import { cn } from "./cn";

export function Avatar({ name, kind, small = false, online, photoUrl }: { name: string; kind?: string | undefined; small?: boolean | undefined; online?: boolean | undefined; photoUrl?: string | null | undefined }) {
  const showPhoto = typeof photoUrl === "string" && photoUrl.length > 0 && kind !== "openclaw";
  return (
    <span className={cn("avatar", small && "avatar--small", showPhoto && "avatar--photo", `avatar--${avatarColor(name, kind)}`)} aria-hidden="true">
      {showPhoto ? <PrivateImage src={photoUrl} alt="" loading="lazy" decoding="async" /> : kind === "openclaw" ? <Bot size={small ? 13 : 17} /> : initials(name)}
      {online === true ? <span className="presence-dot" /> : null}
    </span>
  );
}
